import { Empty } from 'antd';
import type { ReactNode } from 'react';

export function EmptyState({ title, body, action }: { title: string; body?: string; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<><div style={{ fontWeight: 600 }}>{title}</div>{body ? <p>{body}</p> : null}</>}>{action}</Empty>
    </div>
  );
}
